import { Component, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';

import { InstrumentRunTableData } from '../../../interfaces/instrument-run';
import { InfoPanelComponent } from '../../../shared/info-panel/info-panel.component';
import { InfoPanelExpansionSectionComponent } from '../../../shared/info-panel/expansion-section-component/info-panel-expansion-section.component';
import { InfoPanelFieldComponent } from '../../../shared/info-panel/field-component/info-panel-field.component';
import { UtcDatePipe } from '../../../shared/pipes/utc-date.pipe';
import { InfoPanelSectionComponent } from '../../../shared/info-panel/section-component/info-panel-section.component';
import { InfoPanelListFieldComponent } from '../../../shared/info-panel/list-field-component/info-panel-list-field.component';
import { FileSizePipe } from '../../../shared/pipes/file-size/file-size.pipe';

@Component({
  selector: 'app-instrument-run-info-panel',
  standalone: true,
  imports: [
    InfoPanelComponent,
    InfoPanelSectionComponent,
    InfoPanelFieldComponent,
    UtcDatePipe,
    InfoPanelListFieldComponent,
    FileSizePipe,
  ],
  templateUrl: './instrument-run-info-panel.component.html',
})
export class InstrumentRunInfoPanelComponent {
  @ViewChildren(InfoPanelExpansionSectionComponent) private sections!: QueryList<InfoPanelExpansionSectionComponent>;

  @Input() run: InstrumentRunTableData | null = null;

  private _isOpen = false;
  @Input() set isOpen(value: boolean) {
    this._isOpen = value;
    if (!value) {
      setTimeout(() => this.sections?.forEach((s) => s.reset()), 225);
    }
  }
  get isOpen(): boolean {
    return this._isOpen;
  }

  @Output() closed = new EventEmitter<void>();

  get title(): string {
    return this.run ? $localize`Instrument Run #${this.run.runID}` : $localize`Instrument Run`;
  }
}
